module.exports = __webpack_public_path__ + "images/arrow-backce236a39067163d6556d594c2fa576fa.svg";